import React from 'react';
import { Logo } from './Logo';
import { Facebook, Twitter, Instagram, Linkedin, MessageCircle } from 'lucide-react';
export function Footer() {
  return <footer className="bg-white border-t border-slate-100 pt-16 pb-8" data-id="element-35">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-36">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-16" data-id="element-37">
          {/* Brand */}
          <div data-id="element-38">
            <Logo className="mb-6" data-id="element-39" />
            <p className="text-slate-500 leading-relaxed mb-6" data-id="element-40">
              UK's premier digital marketing agency dedicated to driving
              measurable growth for businesses through SEO and PPC excellence.
            </p>
            <div className="flex gap-4" data-id="element-41">
              <a href="#" className="text-slate-400 hover:text-emerald-500 transition-colors" data-id="element-42">
                <Facebook className="w-5 h-5" data-id="element-43" />
              </a>
              <a href="#" className="text-slate-400 hover:text-emerald-500 transition-colors" data-id="element-44">
                <Twitter className="w-5 h-5" data-id="element-45" />
              </a>
              <a href="#" className="text-slate-400 hover:text-emerald-500 transition-colors" data-id="element-46">
                <Instagram className="w-5 h-5" data-id="element-47" />
              </a>
              <a href="#" className="text-slate-400 hover:text-emerald-500 transition-colors" data-id="element-48">
                <Linkedin className="w-5 h-5" data-id="element-49" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div data-id="element-50">
            <h3 className="font-bold text-slate-900 mb-6" data-id="element-51">Quick Links</h3>
            <ul className="space-y-3" data-id="element-52">
              <li data-id="element-53">
                <a href="#" className="text-slate-500 hover:text-emerald-600 transition-colors" data-id="element-54">
                  Home
                </a>
              </li>
              <li data-id="element-55">
                <a href="#about" className="text-slate-500 hover:text-emerald-600 transition-colors" data-id="element-56">
                  About Us
                </a>
              </li>
              <li data-id="element-57">
                <a href="#services" className="text-slate-500 hover:text-emerald-600 transition-colors" data-id="element-58">
                  Services
                </a>
              </li>
              <li data-id="element-59">
                <a href="#process" className="text-slate-500 hover:text-emerald-600 transition-colors" data-id="element-60">
                  Our Process
                </a>
              </li>
              <li data-id="element-61">
                <a href="#faq" className="text-slate-500 hover:text-emerald-600 transition-colors" data-id="element-62">
                  FAQ
                </a>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div data-id="element-63">
            <h3 className="font-bold text-slate-900 mb-6" data-id="element-64">Services</h3>
            <ul className="space-y-3" data-id="element-65">
              <li data-id="element-66">
                <a href="#" className="text-slate-500 hover:text-emerald-600 transition-colors" data-id="element-67">
                  SEO Optimization
                </a>
              </li>
              <li data-id="element-68">
                <a href="#" className="text-slate-500 hover:text-emerald-600 transition-colors" data-id="element-69">
                  PPC Management
                </a>
              </li>
              <li data-id="element-70">
                <a href="#" className="text-slate-500 hover:text-emerald-600 transition-colors" data-id="element-71">
                  Content Marketing
                </a>
              </li>
              <li data-id="element-72">
                <a href="#" className="text-slate-500 hover:text-emerald-600 transition-colors" data-id="element-73">
                  Local SEO
                </a>
              </li>
              <li data-id="element-74">
                <a href="#" className="text-slate-500 hover:text-emerald-600 transition-colors" data-id="element-75">
                  Technical Audits
                </a>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div data-id="element-76">
            <h3 className="font-bold text-slate-900 mb-6" data-id="element-77">Contact Us</h3>
            <p className="text-slate-500 mb-6" data-id="element-78">
              Ready to start? Contact us directly on WhatsApp for immediate
              assistance.
            </p>
            <a href="https://wa.me/447921876472" target="_blank" rel="noopener noreferrer" className="flex flex-col items-center justify-center gap-2 bg-[#25D366] text-white p-4 rounded-xl hover:bg-[#20bd5a] transition-colors text-center group" data-id="element-79">
              <div className="flex items-center gap-2" data-id="element-80">
                <MessageCircle className="w-6 h-6 fill-current" data-id="element-81" />
                <span className="font-bold text-lg" data-id="element-82">WhatsApp Us</span>
              </div>
              <span className="font-mono text-sm opacity-90 group-hover:opacity-100" data-id="element-83">
                +44 7921 876472
              </span>
            </a>
          </div>
        </div>

        <div className="border-t border-slate-100 pt-8 text-center text-slate-400 text-sm" data-id="element-84">
          <p data-id="element-85">
            &copy; {new Date().getFullYear()} SEO PPC Co. All rights reserved.
          </p>
        </div>
      </div>
    </footer>;
}